import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader.js";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";

const gltfLoader = new GLTFLoader();
const dracoLoader = new DRACOLoader();
dracoLoader.setDecoderPath(
    "https://unpkg.com/three@0.165.0/examples/jsm/libs/draco/gltf/"
);
gltfLoader.setDRACOLoader(dracoLoader);

/**
 * Properly disposes of a WebGL renderer and its associated resources
 * @param {WebGLRenderer} renderer - The Three.js WebGLRenderer to dispose
 * @param {Scene} [scene] - Optional scene to traverse and dispose of geometries/materials
 * @param {Object} [options] - Additional options
 * @param {Object} [options.controls] - OrbitControls or other controls to dispose
 */
function disposeRenderer(renderer, scene = null, options = {}) {
    if (!renderer) return;

    // Dispose of all geometries, materials, and textures in the scene
    if (scene) {
        scene.traverse((object) => {
            if (object.geometry) {
                object.geometry.dispose();
            }
            if (object.material) {
                if (Array.isArray(object.material)) {
                    object.material.forEach((material) => {
                        if (material.map) material.map.dispose();
                        if (material.normalMap) material.normalMap.dispose();
                        if (material.roughnessMap)
                            material.roughnessMap.dispose();
                        if (material.metalnessMap)
                            material.metalnessMap.dispose();
                        if (material.envMap) material.envMap.dispose();
                        material.dispose();
                    });
                } else {
                    if (object.material.map) object.material.map.dispose();
                    if (object.material.normalMap)
                        object.material.normalMap.dispose();
                    if (object.material.roughnessMap)
                        object.material.roughnessMap.dispose();
                    if (object.material.metalnessMap)
                        object.material.metalnessMap.dispose();
                    if (object.material.envMap)
                        object.material.envMap.dispose();
                    object.material.dispose();
                }
            }
        });
    }

    // Dispose of the renderer (this handles programs, textures, etc.)
    renderer.dispose();

    // Force lose the WebGL context to free it immediately
    const gl = renderer.getContext();
    if (gl) {
        const loseContext = gl.getExtension("WEBGL_lose_context");
        if (loseContext) {
            loseContext.loseContext();
        }
    }

    // Dispose of controls if provided
    if (options.controls) {
        options.controls.dispose();
    }
}

export { gltfLoader, dracoLoader, disposeRenderer };
